export function scoreTone(score) {
    if (score == null) return 'blue';
    if (score >= 80) return 'green';
    if (score >= 60) return 'yellow';
    return 'red';
}

export function scoreRating(score) {
    if (score == null) return 'Pending';
    if (score >= 80) return 'Strong Match';
    if (score >= 60) return 'Developing';
    return 'Growth Area';
}

export function overallHeadline(score) {
    if (score == null) return 'Your analysis is being processed.';
    if (score >= 80) return "Strong alignment. Focus on standing out even more.";
    if (score >= 60) return "Solid foundation. A few targeted improvements will help.";
    return "Key gaps to address. Let's close them.";
}

// "green" is the positive/high-score band — kept as the semantic success
// color (not brand primary blue), since "blue" already means a distinct
// state here (score pending).
export const PILL_LIGHT = { green: 'bg-success-tint text-success', yellow: 'bg-amber-100 text-amber-800', red: 'bg-rose-100 text-rose-800', blue: 'bg-blue-100 text-blue-800' };
export const PILL_DARK = { green: 'bg-success/20 text-success', yellow: 'bg-amber-900/40 text-amber-300', red: 'bg-rose-900/40 text-rose-300', blue: 'bg-blue-900/40 text-blue-300' };
export const BAR = { green: 'bg-success', yellow: 'bg-amber-500', red: 'bg-rose-500', blue: 'bg-blue-400' };
